module.exports = __webpack_public_path__ + "static/media/21ECLAC35.c33af34a.jpg";